import React from "react";

const Services = () => {
  return (
    <div className="page">
      <div className="container">
        <div className="page-wrapper">
          <h2>This is services page.</h2>
        </div>
      </div>
    </div>
  );
};

export default Services;
